import React from 'react';

const UserCreatePage = React.lazy(() => import('../pages/users/UserCreatePage/UserCreatePage'));
const UserDetailPage = React.lazy(() => import('../pages/users/UserDetailPage/UserDetailPage'));
const UsersPage = React.lazy(() => import('../pages/users/UsersPage/UsersPage'));
const UsersBackOfficePage = React.lazy(() => import('../pages/users/UsersBackOfficePage/UsersBackOfficePage'));

export const PATH_USER = '/user/:guid/:step?';
export const PATH_USERS = '/users';
export const PATH_USER_CREATE = '/user/create';

export const PATH_USER_ADMIN = '/users-admin';
export const PATH_USER_CREATE_ADMIN = '/user/create-admin';

const PAGE_USER = {
  component: UserDetailPage,
  path: PATH_USER,
};

const PAGE_USERS = {
  component: UsersPage,
  path: PATH_USERS,
};

const PAGE_USER_ADMIN = {
  component: UsersBackOfficePage,
  path: PATH_USER_ADMIN,
};

const PAGE_USER_CREATE = {
  component: UserCreatePage,
  path: PATH_USER_CREATE,
};

const PAGE_USER_CREATE_ADMIN = {
  component: UserCreatePage,
  path: PATH_USER_CREATE_ADMIN,
};

// IMPORTANT: The order in which the pages are added is important
export default [PAGE_USER_CREATE, PAGE_USER_CREATE_ADMIN, PAGE_USER, PAGE_USERS, PAGE_USER_ADMIN];
